import { schema } from 'normalizr';

export default new schema.Entity(
  'positions',
  {},
  {
    idAttribute: 'lid',
  }
);
